/**
 * isEmbedSurface — Iter 69.
 *
 * True when the current page is being rendered inside one of our
 * `/embed/*` iframe routes OR when the document is loaded inside any
 * iframe at all. We use it to silence "global" overlays (cookie banner,
 * PWA install prompt, re-engagement tip, chat bubble) that have no
 * business overlapping a partner-site's embed of our search widget.
 *
 * Two conditions covered:
 *   1. Path starts with `/embed/` — our own embed routes (microsite,
 *      vendor widget, search widget). Most reliable check.
 *   2. `window.self !== window.top` — any iframe context. Catches the
 *      "previewing your own embed inside the widget builder" case where
 *      the iframe URL is on the same origin but we still want a clean
 *      preview.
 *
 * SSR-safe (returns false in environments with no window).
 */
export function isEmbedSurface() {
  if (typeof window === "undefined") return false;
  try {
    if (window.location.pathname.startsWith("/embed/")) return true;
  } catch (_e) { /* SecurityError on cross-origin parent — fall through */ }
  try {
    if (window.self !== window.top) return true;
  } catch (_e) {
    // SecurityError when window.top isn't accessible (cross-origin
    // iframe) — that itself means we're embedded.
    return true;
  }
  return false;
}
